<!--模板-->
<template>
  <div id="customization">
    <div class="content_bg">
      <h3>团队、企业定制服务</h3>
      <table>
        <tr>
          <td>企业名称</td>
          <td>
            <div style="width: 220px;display: inline-block">
              <el-input v-model="enterprise" placeholder="请输入企业名称"></el-input>
            </div>
          </td>
        </tr>
        <tr>
          <td>联系人</td>
          <td>
            <div style="width: 220px;display: inline-block">
              <el-input v-model="name" placeholder="请输入联系人姓名"></el-input>
            </div>
          </td>
        </tr>
        <tr>
          <td>联系电话</td>
          <td>
            <div style="width: 220px;display: inline-block">
              <el-input v-model="iphone" placeholder="请输入联系人电话"></el-input>
            </div>
          </td>
        </tr>
      </table>
      <h5 style="margin-bottom: 30px">告诉我们您的更多计划信息，以便我们更好地为您安排计划，例如：您的出行要求，出行需求，目的地情况等，您是我们的重要客户，我们竭尽全力为您安排一步到位！~</h5>
      <el-input
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 4}"
        placeholder="请输入您的备注要求描述~"
        v-model="requireText">
      </el-input>

      <div class="btn_bg">
        <el-button type="primary" @click="addBtn">提交团队计划</el-button>
      </div>
    </div>
  </div>
</template>


<!--JS-->
<script>
  export default {
    data() {
      return {
        checkList:[],
        requireText:'',
        nameNum:1,
        startTime:'',
        endTime:'',
        city:'',
        enterprise:'',
        name:'',
        iphone:''
      };
    },
    methods:{
      handleChange(key){

      },
      addBtn(){
        if(this.enterprise == ''){
          this.$message.error('请填写企业名称')
          return false
        }
        if(this.name == ''){
          this.$message.error('请填写您的姓名')
          return false
        }
        if(this.iphone == ''){
          this.$message.error('请填写你的电话')
          return false
        }
        console.log(this.enterprise)
        console.log(this.name)
        console.log(this.iphone)
        console.log(this.requireText)
        this.$message.success('您的信息，已提交到总部，我们会尽快与您取得联系！')
      }
    }
  };
</script>


<!--css样式-->
<style lang="scss" scoped>
  @import '../../scss/commonH5';
  .btn_bg{
    margin: 20px auto;
    text-align: center;
  }
  #customization{
    width: 100%;
    min-height: 60vh;
    color:#fff;
  }
  .content_bg{
    width: 1000px;
    margin: 50px auto;
    h3{
      text-align: center;
      margin: 10px 0;
    }
    table{
      margin: 30px 0;
      border-top:1px solid #ddd ;
      border-bottom:1px solid #ddd ;
      width: 100%;
      tr{
        width: 100%;
        display: flex;
      }
      td{
        padding: 20px 0;
        font-size: 17px;
      }
      td:first-child{
        width: 120px;
      }
      td:last-child{
        flex: 1;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/customization/team.vue